import {
  flow,
  Instance,
  types,
  applySnapshot,
  getSnapshot
} from 'mobx-state-tree'
import { PageInfoModel, PageInfoModelCreation } from '.'
import { AnnouncementsModel } from './AnnouncementsModel'
import loggedInUser from './loggedInUser'
import { Preferences } from './PreferencesModel'
import { RootStoreBase } from './RootStore.base'
import { StatusModel } from './StatusModel'
import { CurrentViewModel } from './ViewModel'
import { WarningsModel } from './WarningsModel'
import { ProgramsModel } from './ProgramsModel'
export interface RootStoreType extends Instance<typeof RootStore> {}

export const RootStore = RootStoreBase.props({
  view: CurrentViewModel,
  loggedInUser,
  preferences: Preferences,
  announcements: types.optional(AnnouncementsModel, {}),
  // chats: types.optional(ChatsModel, { withSelf: { messages: [] } }),
  // users: types.array(UserModel),
  warnings: types.optional(WarningsModel, {}),
  status: types.optional(StatusModel, {}),
  chatsPagination: types.optional(PageInfoModel, {}),
  programs: types.optional(ProgramsModel, {})
})
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    },
    setLoggedInUser(input: Instance<typeof self.loggedInUser>) {
      self.loggedInUser = input
        ? loggedInUser.create({ accessToken: input.accessToken })
        : null
    },

    login({ email, password }: { email: string; password: string }) {
      const query = self.mutateUserLogin({ email, password })
      query
        .then(
          data =>
            (self.loggedInUser = loggedInUser.create({
              accessToken: data.userLogin.accessToken!
            })),
          error => {
            console.error('caught error in login', error)
            throw error
          }
        )
        .then(
          () => {
            // do nothing
          },
          rejected => {
            console.error('caught outside login then', rejected)
          }
        )

      return query
    },
    loginWithGoogle() {
      window.history.pushState(null, '', window.location.href)
      window.location.replace(
        `${process.env.REACT_APP_SERVER_BASE_URL}/auth/login-with-google`
      )
    },

    logout() {
      console.log('logging out')
      self.mutateUserLogout()
      const preferences = getSnapshot(self.preferences)
      const status = getSnapshot(self.status)
      applySnapshot(self, { preferences, status })
    }
  }))
  .actions(self => ({
    refreshAccessToken: flow(function* refreshToken() {
      const response: Response = yield fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/auth/refresh-token`,
        {
          method: 'POST',
          credentials: 'include'
        }
      )
      const json: { accessToken: string; ok: boolean } = yield response.json()
      console.log(json)
      if (json.ok) {
        if (!self.loggedInUser)
          self.loggedInUser = loggedInUser.create({
            accessToken: json.accessToken
          })
        else self.loggedInUser.accessToken = json.accessToken
      } else self.logout()
    })
  }))
  .actions(self => ({
    changePasswordWithToken: flow(function* changePasswordWithToken(
      token: string,
      email: string,
      newPassword: string
    ) {
      const response: Response = yield fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/auth/change-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ token, newPassword }),
          credentials: 'include'
        }
      )

      yield response.json()
      self.view.openHomePage()
      self.login({ email, password: newPassword })
    }),
    setChatsPagination(pageInfo: PageInfoModelCreation) {
      applySnapshot(self.chatsPagination, pageInfo)
    }
  }))
  .actions(self => ({
    async loadChats() {
      if (!!self.loggedInUser?.user?.$permissions?.chatAsFrontDesk) {
        const after = self.chatsPagination.endCursor || ''
        const filter: Record<string, number | string> = { first: 2 }
        if (after) filter.after = after

        const result = await self.queryChatGetRecentChats(filter, s =>
          s
            .edges(e =>
              e.cursor.node(n =>
                n.id.lastReadTimestamp
                  .messages(m =>
                    m
                      .pageInfo(p => p.endCursor.hasNextPage)
                      .edges(e =>
                        e.cursor.node(n =>
                          n._id.content.author(a => a.id.email.profilePhoto)
                        )
                      )
                  )
                  .user(u => u.email.id.profilePhoto)
              )
            )
            .pageInfo(p => p.endCursor.hasNextPage)
        )

        self.setChatsPagination(result.chatGetRecentChats.$pageInfo)
        console.log(result, applySnapshot)
      } else {
        await self.queryChatGetMessages(
          {
            chatId: self.loggedInUser?.id || '',
            first: 50
          },
          n =>
            n.id.lastReadTimestamp
              .messages(m =>
                m
                  .pageInfo(p => p.endCursor.hasNextPage)
                  .edges(e =>
                    e.cursor.node(n =>
                      n._id.content.author(a => a.id.email.profilePhoto)
                    )
                  )
              )
              .user(u => u.email.id.profilePhoto)
        )
      }
    },
    async loadAnnouncements() {
      await self.queryGetActiveAnnouncements(
        undefined,
        s =>
          s.body.createdAt.createdByUser.highPriority.id.publishEnd.publishStart.sendAlert.stats(
            s => s.person(p => p._id.email.name).readTimestamp
          ).subject.audience
      )
    }
  }))
  .actions(self => ({
    clearAndReload: flow(function* () {
      self.setChatsPagination({ endCursor: '' })
      yield Promise.all([self.loadChats(), self.loadAnnouncements()])
    })
  }))
